/**
 * Marks a tab's main table — its MRT paper — as the thing a phone-width pane gives the rest of the tab
 * to, and lets it reach the pane's edges.
 *
 * On a narrow pane a tab is a stack, and its table used to end under its last row with the scrollbar
 * there and the rest of the tab empty beneath it; the product owner wants the table down to the
 * traverser and across the whole width, the way the Fee Schedule tab's has always been (#5907). Every
 * tab wraps its table in different containers, and every one of them would have had to learn to grow.
 * So the pane says it once, the way it says its gutter: whatever holds a marked table grows, and the
 * marked table climbs out of the gutter. See `workPaneGutters` in `work/_views/work-pane-layout`, which
 * owns the rule; this module holds only the mark, so a shared table can carry it without importing a
 * work page's layout.
 *
 * Only the tab's own table. A template picker's table sits inside a bordered accordion, which neither
 * grows nor wants a table hanging out of it.
 */
export const PANE_STRETCH_ATTRIBUTE = "data-pane-stretch";

/** Spread onto the table's paper props: `muiTablePaperProps: { ...paneStretchTable }`. */
export const paneStretchTable = { "data-pane-stretch": "" } as const;
